import { render, staticRenderFns } from "./admin_users_roles.vue?vue&type=template&id=14e56dc2&scoped=true&"
import script from "./admin_users_roles.vue?vue&type=script&lang=js&"
export * from "./admin_users_roles.vue?vue&type=script&lang=js&"
import style0 from "./admin_users_roles.vue?vue&type=style&index=0&id=14e56dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e56dc2",
  null
  
)

export default component.exports